module.exports = __webpack_public_path__ + "static/media/landingbgSM.50484f82.png";